import React, { useEffect, useState } from 'react'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import DateFormat from '../../../../utils/NuDate';
import { OnDownload } from '../../../../utils/OtherFunctions';
import { NormalButton } from '../../../../utils/Button';

function TaskMangementXlsx({fileName,data ,status,standardname="",review,Name,startDate,endDate,company,Module,standardId,updateLenth}) {
    const [csvData,setCSVData] = useState([])


    useEffect(()=>{
        if(data){
            let finalData = []
            data && data.map((item,index)=>{
                updateLenth(index+1)
                let tempData = {
                    "Sl.No":item?.serial_number||"",
                    "Task":item?.task_id == 1?"Implementation Checklist":item?.task_id == 2?"Internal Audit":item?.task_id == 3?"Maintenance":item?.task_id == 4?"Master List of Documents":item?.task_id == 18?"CISO / MRM Meeting ":item?.task_id == 6?"Audit Schedule":"" ||"",
                    "Title":item?.title||"",
                    "Comments":item?.user_response||"",
                    "Completion Date":item?.completion_date!=="None"&&item?.completion_date!==""&&`${DateFormat({value:item?.completion_date, format:"DD-MMM-YYYY"})}`||"",
                    "Reminder Date":item?.reminder_date!=="None"&&item?.reminder_date!==""&&`${DateFormat({value:item?.reminder_date, format:"DD-MMM-YYYY"})}`||"",
                    "Status":item?.status||"",
                    "Last Update by":item?.last_modified_name || item?.created_name || item?.created_by_name || "",
                    // "Attachment Artefact":item?.attachment==true?"Yes":""
                }
                finalData.push(tempData);
            })
            setCSVData(finalData);
            
        }
    },[data])

    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const exportToCSV = (csvData, fileName) => {
      const ws = XLSX.utils.json_to_sheet(csvData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
      OnDownload(standardId,Module)

    };
    return (
      // <div onClick={()=>exportToCSV(csvData,fileName)}>ExportXls</div>
    //   <button onClick={()=>exportToCSV(csvData,fileName)}>Download</button>
     <NormalButton label='Download' handleClick={()=>exportToCSV(csvData,fileName)}/>
    )
}

export default TaskMangementXlsx;